export default class BOMMap {
  constructor() {
    this.currentOrder = 0;
    this.referencesMap = {};
  }

  addReferencesToBOMMap = (reference, quantity, description = null) => {
    if (this.referencesMap[reference]) {
      this.referencesMap[reference].quantity += quantity;
    } else {
      this.referencesMap[reference] = {reference, description, quantity, order: this.currentOrder++ };
    }
  };

  mergeBOMMaps = (bomMap) => {
    for (const value of Object.values(bomMap.referencesMap)) {
      this.addReferencesToBOMMap(value.reference, value.quantity, value.description);
    }
  };

  extractSortedReferences = () => {
    return Object.values(this.referencesMap)
      .sort(function (a, b) { return a.order - b.order });
  }

  extractDistinctReferences = () => {
    return this.extractSortedReferences()
      .map(ref => ref.reference);
  }
}
